// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"428":"baabbac8","542":"d31c2e7f","639":"b0f48124","662":"6b43e9cd","727":"68cca9c0","762":"63877fed","836":"4060447e","843":"9569eb58","900":"95f781ce"}[chunkId] + ".chunk.js";
};